import SalesQuote from "../../../../src/pages/use-cases/page-content/financial/sales-quote.md";
import * as React from 'react';
export default {
  SalesQuote,
  React
};